import { useActiveOrgMember } from '~/hooks/org/useActiveOrgMember'
import { useCanCreateAnyTransaction } from '~/hooks/useTransactions'

export const useCanOfframpOrOnramp = () => {
  const canCreateAnyTransaction = useCanCreateAnyTransaction()

  const orgMember = useActiveOrgMember()
  const isOwner = orgMember?.role === 'OWNER'

  return canCreateAnyTransaction && isOwner
}
